import type { RegionalOverviewNavigation, RegionalOverviewNavigationState } from '@features/regional-overview';
import { emitNativeNavigation, hasDirectNavigationTransport } from '../../infra/embedded-webview/native-navigation';

export const createRiskManagementNavigation = (): RegionalOverviewNavigation | undefined => {
  if (typeof window === 'undefined') return undefined;

  const marker = new URLSearchParams(window.location.search).get('protectorRiskManagementNavigation');
  const hasNativeTransport = hasDirectNavigationTransport();

  if (marker === '1' && hasNativeTransport) {
    let sequence = 0;
    let lastRenderedState: RegionalOverviewNavigationState | undefined;
    let rootExitSent = false;
    const envelope = () => ({ source: 'risk-management-navigation', version: 1, sequence: ++sequence });

    return {
      reportRenderedState: state => {
        if (lastRenderedState === state) return;
        lastRenderedState = state;
        rootExitSent = false;
        emitNativeNavigation({ ...envelope(), type: 'rendered-state', state });
      },
      onHomeBack: () => {
        if (lastRenderedState !== 'home' || rootExitSent) return;
        rootExitSent = true;
        emitNativeNavigation({ ...envelope(), type: 'root-exit' });
      }
    };
  }

  return undefined;
};
